import script from "./DevComponentContainer.vue?vue&type=script&lang=js"
export * from "./DevComponentContainer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__